"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFinishedTournaments = void 0;
var tournament_api_1 = require("@l2p/tournament-api");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useFinishedTournaments = function () {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.TOURNAMENTS_FINISHED,
        payload: {
            status: tournament_api_1.TournamentStatusEnum.Finished,
            currency: currentCurrency,
            lang: lang,
        },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useFinishedTournaments = useFinishedTournaments;
